import { render } from "./TelegramBottomNav.vue?vue&type=template&id=0560bbe1&scoped=true"
const script = {}

import "./TelegramBottomNav.vue?vue&type=style&index=0&id=0560bbe1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0560bbe1"]])

export default __exports__